module.exports = __webpack_public_path__ + "501db4f894edaeed6d5f31944b50f4a2.MP3";